var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJiraPriorityArrowTriage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.5056C13.3835 14.5056 14.505 13.384 14.505 12.0006C14.505 10.6171 13.3835 9.49552 12 9.49552C10.6165 9.49552 9.49496 10.6171 9.49496 12.0006C9.49496 13.384 10.6165 14.5056 12 14.5056ZM12 16.0086C14.2136 16.0086 16.0081 14.2141 16.0081 12.0006C16.0081 9.78696 14.2136 7.99249 12 7.99249C9.78641 7.99249 7.99194 9.78696 7.99194 12.0006C7.99194 14.2141 9.78641 16.0086 12 16.0086Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.997C15.312 17.997 17.997 15.312 17.997 12C17.997 8.68796 15.312 6.00302 12 6.00302C8.68796 6.00302 6.00302 8.68796 6.00302 12C6.00302 15.312 8.68796 17.997 12 17.997ZM12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraPriorityArrowTriage);
export default __webpack_public_path__ + "static/media/jira-priority-arrow-triage.c6bd0c596d88ce317f2955f009e239a9.svg";
export { ForwardRef as ReactComponent };